export default __webpack_public_path__ + "static/media/dotzBg.07d146cd.jpg";